/**
 * @generated SignedSource<<c34bd9fac93d6a7e4c09e6ba7a2f6d51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderApp_chargePaymentLink$data = {
  readonly correlationID: string | null | undefined;
  readonly id: string;
  readonly metaPixel: {
    readonly token: string | null | undefined;
  } | null | undefined;
  readonly redirectUrl: string | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Order_charge" | "useMeta_charge">;
  readonly " $fragmentType": "OrderApp_chargePaymentLink";
};
export type OrderApp_chargePaymentLink$key = {
  readonly " $data"?: OrderApp_chargePaymentLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderApp_chargePaymentLink">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationMetaPixel",
  "kind": "LinkedField",
  "name": "metaPixel",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderApp_chargePaymentLink",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Order_charge"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeta_charge",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redirectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correlationID",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "51d966ef28e81dc24b6dd250b410ee21";

export default node;
